import { render, staticRenderFns } from "./SalesPaymentListTable.vue?vue&type=template&id=67f8f2b1"
import script from "./SalesPaymentListTable.vue?vue&type=script&lang=js"
export * from "./SalesPaymentListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports